import { useDispatch, useSelector } from 'react-redux';
import { ValidationsList } from "../View/ValidationsList";

const LeftContent = () => {
  return (
    <div className="p-2">
      <ValidationsList />
    </div>
  )
};

export default LeftContent;